import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { AppState } from '~/store/app.store';
import {
  activeBoundaryTerritoryGroupsSelector,
  boundaryTerritoryGroupsSelector, BTGsGroupedByBoundaryGroupSelector,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const dataLayersBTGsSelector = createStateSelector([
  boundaryTerritoryGroupsSelector,
], (boundaryTerritoryGroups: readonly BoundaryTerritoryGroup[]): readonly BoundaryTerritoryGroup[] => {
  return boundaryTerritoryGroups.filter(btg => isDataLayersArtificialBoundaryTerritoryGroup(btg));
});
export const useDataLayersBTGsSelector = () => useSelector(dataLayersBTGsSelector);

export const useDataLayersToolBTGsGroupedByBoundaryGroupSelector = () => useSelector(BTGsGroupedByBoundaryGroupSelector).dataLayersTool;

export const dataLayersToolActiveBTGsSelector = (state: AppState) => activeBoundaryTerritoryGroupsSelector(state, true);
export const useDataLayersToolActiveBTGsSelector = () => useSelector(dataLayersToolActiveBTGsSelector);
